import React, { useMemo } from 'react'
import { useSelector, shallowEqual } from 'dva'
import { Typography, Tabs } from 'antd'
import { TabsProps } from 'rc-tabs'
import {
  BaseInfo,
  MemberInfo,
  AvailableLimit,
  Address,
  EnterpriseArchives,
} from './components'

const { Title } = Typography

type Props = {}

const items = ({ roleCodes }) => {
  let list: TabsProps['items'] = []
  // 管理员
  if (roleCodes.includes('role:root')) {
    list = [
      {
        key: '1',
        label: '个人信息',
        children: <BaseInfo />,
      },
      {
        key: '2',
        label: '成员信息',
        children: <MemberInfo />,
      },
      {
        key: '3',
        label: '可用额度',
        children: <AvailableLimit />,
      },
      {
        key: '4',
        label: '收货地址管理',
        children: <Address />,
      },
      {
        key: '5',
        label: '企业档案',
        children: <EnterpriseArchives />,
      },
    ]
  }
  // 管理员
  else if (roleCodes.includes('role:common')) {
    list = [
      {
        key: '1',
        label: '个人信息',
        children: <BaseInfo />,
      },
      {
        key: '3',
        label: '可用额度',
        children: <AvailableLimit />,
      },
      {
        key: '4',
        label: '收货地址管理',
        children: <Address />,
      },
    ]
  }
  return list
}

const selector = ({ cart, login }) => ({
  userInfo: login.userInfo || {},
})
const ID = (props: Props) => {
  const { userInfo } = useSelector(selector, shallowEqual)

  // 权限
  const roleCodes = useMemo(() => {
    let codes = userInfo?.roles?.map(c => c.name)
    return codes || []
  }, [userInfo])

  return (
    <div className="mine-id">
      <Title level={5}>账号信息</Title>
      <Tabs items={items({ roleCodes })} destroyInactiveTabPane />
    </div>
  )
}

export default ID
